/* eslint-disable react-hooks/exhaustive-deps */
import {useTranslation} from "react-i18next"
import debounce from "debounce-promise"
import {marketingCampaignsService} from "services"
import {KlassDropAsyncPaginate, KlassDropdownAsyncProps} from "../Select"
import {useQueryClient} from "@tanstack/react-query"

type Props = Partial<KlassDropdownAsyncProps> & {
    componentKey?: string
}

export function CampaignSelect(props: Props) {
    const {t} = useTranslation(["common"])
    const queryClient = useQueryClient()

    const loadOptions = debounce(async (search, loadedOptions) => {
        const pageSize = 10
        const page = Math.ceil(loadedOptions.length / pageSize) + 1
        const queryKey = ["campaigns", search, page, props.componentKey]

        // fetchQuery shares one in-flight request across every select that mounts together.
        // getQueryData does not, so a page of rows each fired its own list call.
        return queryClient.fetchQuery(
            queryKey,
            async () => {
                const {data, total} = await marketingCampaignsService.getAllMarketingCampaigns({
                    range: {page, pageSize},
                    filter: {search}
                })
                return {
                    options: data,
                    hasMore: loadedOptions.length < total
                }
            },
            {staleTime: 5 * 60 * 1000}
        )
    }, 500)

    const formatLabel = (option) => {
        if (!option) return ""
        return option.code ? `[${option.code}] ${option.name}` : option.name
    }

    return (
        <KlassDropAsyncPaginate
            {...props}
            placeholder={props.placeholder || t("selectField.placeholder")}
            loadOptions={loadOptions}
            getOptionLabel={formatLabel}
        />
    )
}
